import { NavLink, useLocation } from "react-router-dom";
import {
	HistoricoProfessionalIcon,
	PropositoIcon,
	FormacionIcon,
	CulturaIcon,
	SalarioIcon,
	HabilidadesIcon,
	MotivacionesIcon,
	DesempenoIcon,
	EntrenamientoIcon,
	PresentationIcon,
} from "../../../../Icons/CollaboratorsIcons";
import { wheelCollaboratorTranslate } from "../../../../i18n/translatedMessages";

import { HiComputerDesktop, HiMiniBriefcase, HiMiniNewspaper, HiMiniPresentationChartLine } from "react-icons/hi2";

import "./SideMenu.sass";
import { useEffect } from "react";

const links = [
	{
		id: 1,
		name: wheelCollaboratorTranslate.professionalHistoric,
		icon: <HistoricoProfessionalIcon />,
		link: "/candidate/professionalinfo",
	},
	{
		id: 2,
		name: wheelCollaboratorTranslate.purpose,
		icon: <PropositoIcon />,
		link: "/candidate/proposito",
	},
	{
		id: 3,
		name: wheelCollaboratorTranslate.formation,
		icon: <FormacionIcon />,
		link: "/candidate/formationinfo",
	},
	{
		id: 4,
		name: wheelCollaboratorTranslate.culture,
		icon: <CulturaIcon />,
		link: "/candidate/climaycultura",
	},
	{
		id: 5,
		name: wheelCollaboratorTranslate.salary,
		icon: <SalarioIcon />,
		link: "/candidate/salaryinfo",
	},
	{
		id: 6,
		name: wheelCollaboratorTranslate.habilities,
		icon: <HabilidadesIcon />,
		link: "/candidate/habilidades",
	},
	{
		id: 7,
		name: wheelCollaboratorTranslate.motivacions,
		icon: <MotivacionesIcon />,
		link: "/candidate/motivaciones",
	},
	{
		id: 9,
		name: wheelCollaboratorTranslate.training,
		icon: <EntrenamientoIcon />,
		link: "/candidate/entrenamiento",
	},
	{
		id: 10,
		name: wheelCollaboratorTranslate.presentacion,
		icon: <PresentationIcon />,
		link: "/candidate/presentation",
	},
	{
		id: 11,
		name: wheelCollaboratorTranslate.referencias,
		icon: <DesempenoIcon />,
		link: "/candidate/references",
	},
	{
		id: 12,
		name: wheelCollaboratorTranslate.salarySurvey,
		icon: <HiMiniPresentationChartLine size={22} />,
		link: "/candidate/show-me-the-money",
	},
	{
		id: 13,
		name: wheelCollaboratorTranslate.outplacement,
		icon: <HiComputerDesktop size={22} />,
		link: "/candidate/genes",
	},
	{
		id: 14,
		name: wheelCollaboratorTranslate.jobs,
		icon: <HiMiniBriefcase size={22} />,
		link: "/candidate/opportunities",
	},
	{
		id: 15,
		name: wheelCollaboratorTranslate.myResume,
		icon: <HiMiniNewspaper size={22} />,
		link: "/candidate/candidatecv",
	},
];

const SideMenu = ({ handleMenu, option }) => {
	const pathname = useLocation().pathname;

	useEffect(() => {
		console.log(pathname);
	}, [pathname]);

	return (
		<div className={pathname === "/candidate" ? "d-none" : "sideMenu-main pe-4"}>
			<ul>
				{links.map((item, key) => {
					return (
						<NavLink key={key} to={item.link}>
							<li
								onClick={handleMenu}
								data-option={item.id}
								className={item.link === pathname ? "active-menu-plan" : ""}
								style={{ background: item.id === 13 ? "#41C8FF" : "" }}
							>
								{item.icon}
								<span>{item.name}</span>
							</li>
						</NavLink>
					);
				})}
			</ul>
		</div>
	);
};
export default SideMenu;
